import { GET_LCBS, GET_LMEnroll, GET_DCById, GET_DCByIdEnroll, GetUserBadge, ADD_Enroll, DLT_Enroll, CHK_Enroll,CEC_LOADING, UPDATE_Email } from "../actions/ExtracurricularCoursesECoursesAction";

const initialState = {
  datos: [],
  datosMyEnrolls: [],
  datosForms: [],
  datosBadge: [],
  datosDCEnroll: [],
  datosIsEnrollment: [],
  loading: false,
  update_email: false
};

const EnrollCourse = function (state = initialState, action) {
  switch (action.type) {
    case CEC_LOADING: {
      return {
        ...state,
        loading: true
      };
    }
    case GET_LCBS: {
      return {
        ...state,
        datos: [...action.data],
        loading: false
      }
    }
    case GET_LMEnroll: {
      return {
        ...state,
        datosMyEnrolls: [...action.data],
        loading: false
      }
    }
    case GET_DCById: {
      return {
        ...state,
        datosForms: [...action.data],
        loading: false
      }
    }
    case GET_DCByIdEnroll: {
      return {
        ...state,
        datosDCEnroll: [...action.data],
        loading: false
      }
    }
    case GetUserBadge: {
      return {
        ...state,
        datosBadge: [...action.data],
        loading: false
      }
    }
    case ADD_Enroll: {
      return {
        ...state,
        datos:[],
        add : true,
        loading: false  
      };
    }
    case UPDATE_Email: {
      return {
        ...state,
        update_email: action.data,
        add : true,
        loading: false  
      };
    }
    case DLT_Enroll: {
      return {
        ...state,
        datos:[],
        add : true,
        loading: false  
      };
    }
    case CHK_Enroll: {
      return {
        ...state,
        datosIsEnrollment: [...action.data],
        loading: false
      }
    }
    default: {
      return {
        ...state,
        loading: false
      }
    }
  }
}

export default EnrollCourse;
